<template>
  <v-img v-bind="props" :src="src" :max-height="maxHeight" contain></v-img>
</template>

<style scoped>

</style>

<script>
  import GhImage from "./ghImage.ts";
  export default GhImage;
</script>